export const SHARED_EVENT_LOAD_REQUESTED = 'SHARED_EVENT_LOAD_REQUESTED';
export const SHARED_EVENT_LOAD_SUCCEEDED = 'SHARED_EVENT_LOAD_SUCCEEDED';
export const SHARED_EVENT_LOAD_FAILED = 'SHARED_EVENT_LOAD_FAILED';
export const SHARED_EVENT_LOAD_CANCELED = 'SHARED_EVENT_LOAD_CANCELED';

export const SHARED_EVENT_SET = 'SHARED_EVENT_SET';
